'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('faq-edit', {
      url: '/faq/edit/:name',
      template: '<faq-edit></faq-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/faq/edit/faq-edit.routes.js